var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mProjectView",attrs:{"id":"mProject"}},[_c('h3',{staticClass:"mTitle mProjectTitle bold",staticStyle:{"text-align":"center"}},[_vm._v(" Projects ")]),_vm._l((_vm.myProjects),function(index,i){return [_c('v-col',{key:i,staticClass:"mProjectCards",attrs:{"cols":"20"}},[_c('mProjectCard',{attrs:{"project":index}})],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }